import React from 'react'
import { NextPage } from 'next'
import { PageProps } from 'types/page'
import { defaultSSRProps } from 'lib/routing/nextPageUtils'
import { DashboardLayout } from 'components/layout/LoggedIn/DashboardLayout'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { AccountSettings } from 'experiences/account/AccountSettings'
import { useLoginRequired } from 'services/Authentication/hooks/useLoginRequired'

const About: NextPage<PageProps> = ({ metaTags }): JSX.Element => {
	useLoginRequired()

	return (
		<StandardLayout metaTags={metaTags}>
			<DashboardLayout>
				<AccountSettings />
			</DashboardLayout>
		</StandardLayout>
	)
}

export const getServerSideProps = defaultSSRProps

export default About
